import React, { PureComponent } from 'react'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import { connect } from 'react-redux'
import { SystemActivityLogPage } from '../../../components/MfeParcels/SystemActivityLogPage'

class SystemActivityLogContainer extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    const { flagReducer = {} } = this.props
    const { isSystemActivityLogEnabled = false } = flagReducer
    return isSystemActivityLogEnabled ? (
      <SystemActivityLogPage
        handleError={(error) => {
          console.log(error)
        }}
      />
    ) : (
      <div />
    )
  }
}

const TaxesPageWithTitle = ContainerWithTitle(SystemActivityLogContainer, 'System Activity Log')

export default connect((state) => ({
  flagReducer: state.flagReducer,
}))(TaxesPageWithTitle)



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/SystemActivityLogMFE.js